import React from 'react'
import Company from '../Components/Company'

function CompanyPage() {
  return (
    <div className = "bg-gradient-to-r from-blue-300 to-blue-400  min-h-screen"><Company/></div>
  )
}

export default CompanyPage